import React, { useContext } from "react";
import "../Faultanalysis/GlossaryPageFaultanalysis.css"
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain from '../DashboardMain/DashboardMain';
import AppContext from '../../../store/AppContext';
import { useState } from "react";

function GlossaryPageFaultanalysis() {
    const app_ctx = useContext(AppContext);
    return (
        <>
            <DashboardMain>
                <body style={{ backgroundColor: "white" }}>
                    <h1 style={{ fontWeight: 'bold', marginTop: "6em", fontSize: "2em" }} align="center">Glossary Page<Link to="/dashboard/faultanalysis" style={{ color: "#32879c", marginLeft: "5%", fontSize: '0.7em' }}><BsSkipBackwardCircleFill /></Link></h1>
                    <table className="table table-hover tableglosary" style={{ width: "50%", height: "20%" }} align="center">
                        <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                            <tr>
                                <th scope="col">Sr.No.</th>
                                <th scope="col">KPI name</th>
                                <th scope="col">Business Logics</th>
                                <th scope="col">Backend Formula</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Vehicle Count
                                </td>
                                <td>Total number of vehicle that were active during the specified time.
                                </td>
                                <td>Distinct Count (VIN)
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Fault active duration
                                </td>
                                <td>Time in minutes in which the faults were active in the vehicle in the specified time frame.
                                </td>
                                <td>Sum (total time) where type = Fault
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Fault active duration per vin
                                </td>
                                <td>Average of the fault duration/vehicle of the fleet
                                </td>
                                <td>Sum (total time) of fault / Number of Vehicle with faults
                                </td>
                            </tr> <tr>
                                <td>4</td>
                                <td>Vehicles with DTCs
                                </td>
                                <td>The number of vehicles with DTCs during the time frame
                                </td>
                                <td>Distinct Count (VIN) where type = DTC
                                </td>
                            </tr> <tr>
                                <td>5</td>
                                <td>Vehicle with Fault
                                </td>
                                <td>The number of vehicle with faults during the time frame
                                </td>
                                <td>Distinct Count (VIN) where type = fault
                                </td>
                            </tr> <tr>
                                <td>6</td>
                                <td>Vehicle with Alarm
                                </td>
                                <td>The number of vehicle with alarms during the time frame
                                </td>
                                <td>Distinct Count (VIN) where type = Alarm
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Percentage of faulty vehicles
                                </td>
                                <td>Percentage of faulty vehicles with respect to total vehicle on the selected dates
                                </td>
                                <td>Number of vehicles in which faults in that date / Total number of vehicles in that date
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>DTC Count
                                </td>
                                <td>The sum of DTC events occurred during the time frame
                                </td>
                                <td>Sum (Occurrence) where type = DTC
                                </td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Fault Count
                                </td>
                                <td>The sum of Fault events occurred during the time frame
                                </td>
                                <td>Sum (Occurrence) where type = Fault
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Alarm Count
                                </td>
                                <td>The sum of Alarm event occurred during the time frame
                                </td>
                                <td>Sum (Occurrence) where type = Alarm
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>DTC Distinct Signals
                                </td>
                                <td>The total number of unique DTC signal detected in the vehicle
                                </td>
                                <td>Distinct Count (l4_signal_name) where type = DTC
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Fault Distinct Signals
                                </td>
                                <td>The total number of unique fault signal detected in the vehicle
                                </td>
                                <td>Distinct Count (l4_signal_name) where type = Fault
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Alarm Distinct Signals
                                </td>
                                <td>The total number of unique alarm signal detected in the vehicle</td>
                                <td>Distinct Count (l4_signal_name) where type = Alarm</td>
                            </tr>
                        </tbody>
                    </table>
                </body>
            </DashboardMain>
        </>
    );
}

export default GlossaryPageFaultanalysis;